import player1 from "@assets/players/1.webp";
import player10 from "@assets/players/10.webp";
import player4 from "@assets/players/4.webp";
import player5 from "@assets/players/5.webp";
import player8 from "@assets/players/8.webp";
import player9 from "@assets/players/9.webp";

const pitch = [
  {
    number: 9,
    avatar: player9,
    role: "center-forward",
    name: "Benzema",
  },
  {
    number: 8,
    avatar: player8,
    role: "center-midfielder-left",
    name: "Kross",
  },
  {
    number: 10,
    avatar: player10,
    role: "center-midfielder-right",
    name: "Modric",
  },
  {
    number: 4,
    avatar: player4,
    role: "center-back-left",
    name: "Ramos",
  },
  {
    number: 5,
    avatar: player5,
    role: "center-back-right",
    name: "Varane",
  },
  {
    number: 1,
    avatar: player1,
    role: "keeper",
    name: "Courtois",
  },
];

export default pitch;
